
import { ConfigProvider, Layout,Spin } from "antd";
import { Content } from "antd/es/layout/layout";
import { HashRouter as Router } from "react-router-dom";
import { ErrorBoundary } from "./common/error-boundary/error-boundary";
import {useState,useEffect } from "react";
import { CommonConstants } from "./constants/commonConstants";
import { LocalStorageKeys } from "./constants/localStorageKeys";
import * as localStorageService from "./service/localStorageService";
import * as lokalizeService from "./service/lokalizeService";
import i18n from "./util/i18n";
import './App.scss';
import LoadRouter from './Router';
import AxiosInterceptorProvider from "./interceptors/axiosInterceptorProvider";
import MobilePage from "./common/mobile-page.jsx/mobile-page";
import AppRedirect from "./AppRedirection";
import { antdThemeFor, brandText } from "./constants/brand";
import { useResolvedThemeMode } from "./common/theme-mode/theme-mode";

function App() {
  const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(true);
  const [isWaitLanguage, setIsWaitLanguage] = useState(true);
  const [direction, setDirection] = useState("ltr");
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [showMobileLanding, setShowMobileLanding] = useState(false);
  const themeMode = useResolvedThemeMode();

  useEffect(() => {
    if (isMobileDevice()) {
      setShowMobileLanding(true);
    }
    else{
    getUserSession();
    }
  }, []);

  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  const getUserSession = () => {
    let lang =  localStorageService.getValue(LocalStorageKeys.Lang);
    lang=lang ? lang
        : CommonConstants.DefaultLanguageCode;
      setUpLokalize(lang);
  }

  const langChanged = (lang) => {
    setUpLokalize(lang);
  };

  
  //set up lokalize
  const setUpLokalize = (selectedLang) => {
    lokalizeService
      .getLanguagePack(selectedLang)
      .then((res) => {
        setIsWaitLanguage(false);

        let arr = res.data.Data;

        let LANGUAGE_KEYS = {};
        arr.forEach((ele) => {
          LANGUAGE_KEYS[ele.Key] = brandText(ele.Value);
        });

        i18n.addResources(selectedLang, "translations", LANGUAGE_KEYS);

        i18n.changeLanguage(selectedLang);
        localStorageService.setKey(LocalStorageKeys.Lang, selectedLang);

        let lang = localStorageService.getValue(selectedLang);

        if (lang != null && lang === CommonConstants.ArabicLanguageCode) {
          setDirection("rtl");
        }
        setIsPageLoaded(true);
      })
      .catch((error) => {
        setIsWaitLanguage(false);
        console.error(error);
      });
  };
  
 

  return (
    
    <ConfigProvider theme={antdThemeFor(themeMode)}>
    <Router>
      <AxiosInterceptorProvider>
        {/* {isWaitLanguage? <Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin>:<LoadRouter />} */}
        {showMobileLanding ? (
          <AppRedirect/>
        ) 
        : isWaitLanguage ? (
          <Spin style={{ marginLeft: "50%", marginTop: "10%" }} />
        ) 
        : (
          <LoadRouter />
        )}
      </AxiosInterceptorProvider>
      </Router>
    </ConfigProvider>
      
  );
}

export default App;
